<!-- Ported from the Polaris kit: src/components/ui/attachment/AttachmentDescription.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <span
    data-slot="attachment-description"
    :class="
      cn(
        'mt-0.5 type-polaris-caption block min-w-0 truncate text-polaris-muted-foreground group-data-[state=error]/attachment:text-polaris-destructive/80',
        'max-w-full',
        props.class
      )
    "
  >
    <slot />
  </span>
</template>
